export const CHAT_HISTORY_KEY = "frontend-chatHistory" as const;
